/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { TranslateService } from '@ngx-translate/core';
import { NbMenuService } from '@nebular/theme';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(
    private analytics: AnalyticsService, 
    private seoService: SeoService, 
    private translate: TranslateService,
    private menuService: NbMenuService,
    private router: Router,
  ) {
    this.menuService.onItemClick()
      .subscribe((event) => {
        this.onContextItemSelection(event.item.title);
      });
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    this.translate.addLangs(['en', 'es']);

    const language = localStorage.getItem('language')
    if(!language) {
      this.translate.setDefaultLang('es');
      this.translate.use('es');
    } else {
      this.translate.setDefaultLang(language);
      this.translate.use(language);
    }
  }

  onContextItemSelection(title) {
    if(this.translate.instant('header.logout') == title) {
      localStorage.removeItem('auth_app_token')
      localStorage.removeItem('user_auth_email')
      this.router.navigateByUrl('/auth/login')
    }
  }
}
